export default {
  nav: {
    home: '首页',
    features: '功能',
    pricing: '定价',
    faq: 'FAQ',
    translate: '漫画翻译',
    startBtn: '开始翻译',
    vip: 'VIP通道',
    login: '登录',
    logout: '退出',
    lang: '中文',
  },
  landing: {
    title: 'KokeManga 智能漫画翻译工具',
    subtitle: 'AI驱动 · 批量翻译 · 原图渲染',
    desc: '免费在线漫画翻译工具，支持JPG、PNG、WEBP等格式',
    hero: {
      badge: 'AI 驱动的漫画翻译',
      title: '智能漫画翻译',
      gradientText: '一键搞定',
      desc: '支持批量上传 · AI 智能识别 · 原图渲染 · 多语言翻译',
      startBtn: '开始翻译',
      learnMore: '了解更多',
      statsTranslated: '累计翻译',
      statsFree: '免费额度',
      statsFreeNum: '20张/天',
      statsAccuracy: '识别准确率',
    },
    comparison: {
      afterLabel: '翻译后',
      beforeLabel: '原图',
    },
    advantage: {
      tag: '为什么选择我们',
      title: '强大的翻译能力',
      desc: '专为漫画翻译打造的 AI 工具，让翻译变得简单高效',
      items: [
        {
          title: 'AI 智能翻译',
          desc: '每张图片均采用 <span class="highlight">大模型翻译，杜绝传统机翻</span>，智能识别文字并保持原始排版风格',
        },
        {
          title: '原图渲染',
          desc: '智能识别漫画风格与背景，对翻译文字进行虚化、修复，完美融入原图风格',
        },
        {
          title: '批量处理',
          desc: '支持批量上传多张漫画图片，一键翻译整个章节，大幅提升工作效率',
        },
        {
          title: '多语言支持',
          desc: '支持中文、繁体中文、英文翻译，后续会出台更多语言',
        },
        {
          title: '隐私安全',
          desc: '全程数据黑箱操作，翻译完成后 <span class="highlight">24 小时无痕清除</span>，不保留任何上传与翻译数据',
        },
        {
          title: '多格式导出',
          desc: '支持 JPG、PNG、WEBP 等多种格式下载，满足不同平台需求',
        },
      ],
    },
    pricing: {
      tag: '算力套餐',
      title: '灵活的定价',
      desc: '获取算力，解锁VIP通道，享受快速翻译、大图翻译等VIP功能。算力永久有效不过期',
      unit: '算力',
      note: '购买的算力永久有效，不过期。VIP通道按次消耗算力，具体消耗量根据图片分辨率计算。',
      packages: [
        { amount: '300 算力', price: '¥6', desc: '约可翻译240-300张漫画' },
        { amount: '600 算力', price: '¥12', desc: '约可翻译480-600张漫画' },
        { amount: '3000+1000 算力', price: '¥60', desc: '约可翻译3200-4000张漫画', badge: '+33%' },
        { amount: '6000+3000 算力', price: '¥120', desc: '约可翻译7200-9000张漫画', badge: '+50%' },
      ],
    },
    channelCompare: {
      title: '通道对比',
      free: {
        title: '公共队列（免费）',
        desc: '适合不着急的用户，排队等待翻译',
        items: ['无需登录', '完全免费，不消耗算力', '队列优先级低', '每日翻译数量限制', '不支持大图翻译（最大2000×2000）'],
      },
      vip: {
        title: 'VIP通道（消耗算力）',
        desc: '快速翻译，支持大图，按次消耗算力',
        items: ['需要登录（免费功能全部权益）', '更多翻译设置', '快速队列，优先翻译', '无次数限制，按次数消耗算力', '支持大图翻译（最大2000×20000）'],
      },
    },
    faq: {
      tag: '常见问题',
      title: 'FAQ',
      desc: '如有其他问题，请联系我们',
      items: [
        { q: '公共队列（免费）能翻译多少张？', a: '我们支持每天免登录翻译 20 张，翻译质量与 VIP 队列一致。' },
        { q: '为啥翻译的时间有点久？', a: '我们采用大模型翻译以保证质量，平均每张图片大模型执行需要 7-8 秒。' },
        {
          q: '为啥有的图片需要更多算力？',
          a: '常规图片基本都是 1 算力，只有长图、超高分辨率的图片才会消耗更多算力。我们的 2 算力换算成分辨率也是大于 4K 的。',
        },
        { q: '翻译出现问题，你们会解决吗？', a: '翻译出现任何问题，我们都保障到底。如果出现失败，会返还失败的算力，保障用户的所有合法权益。' },
        {
          q: '传统机翻和大模型翻译的区别？',
          a: '传统机翻依赖固定规则和词库，翻译生硬、上下文脱节，经常出现语义错误。大模型翻译基于深度学习，能理解上下文语境，翻译更自然流畅，尤其擅长处理漫画中的口语化表达、拟声词和文化梗。',
        },
      ],
    },
    cta: {
      title: '准备好了吗？',
      desc: '开始使用 Koke Manga，体验智能漫画翻译',
      btn: '立即开始翻译',
    },
    footer: {
      features: '功能',
      pricing: '定价',
      faq: 'FAQ',
      login: '登录',
    },
    startBtn: '开始翻译',
  },
    translate: {
    pageTitle: '智能漫画翻译工具',
    pageDesc: '一键上传 · 自动翻译 · 公共队列 · 原图渲染',
    guideArrow: '点击预览',
    uploadTitle: '批量上传漫画',
    previewTitle: '漫画预览',
    historyTitle: '翻译历史',
    batchDownload: '批量下载',
    downloading: '下载中...',
    clearList: '清空列表',
    previewDialog: '效果预览',
    confirm: '确定',
    cancel: '取消',
    systemPrompt: '系统提示',
    reLogin: '重新登录',
    httpError: 'HTTP错误',
    deleteConfirm: '确定删除这个文件吗？',
    deleteTitle: '提示',
    deleteSuccess: '删除成功，已清除后端缓存',
    deleteFailed: '删除失败',
    clearConfirm: '确定清空所有文件记录并清除后端缓存吗？此操作不可恢复',
    clearTitle: '警告',
    clearSuccess: '已清空所有记录并清除后端缓存',
    clearFailed: '清空失败',
    selectFilesFirst: '请先选择要下载的文件',
    invalidFiles: '选中的文件中有 {count} 个文件没有有效的ID，无法下载',
    incompleteFiles: '选中的文件中有 {count} 个文件尚未完成翻译，无法下载',
    downloadingWait: '正在下载中，请稍候...',
    batchDownloadStart: '开始批量下载 {count} 个文件...',
    batchDownloadSuccess: '批量下载成功',
    batchDownloadFailed: '批量下载失败',
    downloadSuccess: '下载成功',
    downloadFailed: '下载失败',
    fileNotFound: '文件不存在或已被删除',
    serverError: '服务器内部错误',
    networkError: '网络异常，请检查网络连接后重试',
    noFileFound: '没有找到对应文件',
    fileIdMissing: '文件ID不存在',
    fileNotComplete: '文件翻译尚未完成，请等待',
    paramError: '请求参数错误，请检查选择的文件',
    privacy: '隐私条款',
    agreement: '用户协议',
    about: '关于我们',
    batchDownloadFilename: '漫画翻译批量下载',
    uploadFirst: '请先上传图片',
    uploadFailed: '上传失败',
    uploadNetworkError: '网络异常',
    uploadResult: '上传结果',
    uploadSuccess: '上传完成！成功 {count} 张',
    joinQueue: '加入翻译队列',
    imageCount: '{current}/{total} 张({size})',
    imagePreview: '漫画预览',
  },
  manga: {
    navbar: {
      home: '首页',
      freeQueue: '免费队列',
      vipQueue: 'VIP队列',
      loggedIn: '已登录',
      currentTasks: '当前任务',
      currentCredits: '当前算力',
      getCredits: '获取算力',
      myOrders: '我的订单',
      myTranslations: '我的翻译',
      profile: '个人信息',
      feedback: '留言建议',
      logout: '退出登录',
      user: '用户',
      taskCount: '{count}个',
    },
    footer: {
      privacy: '隐私条款',
      agreement: '用户协议',
      about: '关于我们',
    },
    queueCard: {
      publicQueue: '公共翻译队列：',
      people: '位',
      realtime: '实时更新 · 全员共用',
      speedQueue: 'Speed加速队列：',
      speedDesc: '每日前100张 · 优先翻译',
      vipQueue: 'VIP专属队列：',
      vipDesc: '快速翻译 · VIP专享',
    },
    upload: {
      dragHint: '点击或拖拽图片到此处',
      translating: '翻译中，请稍候...',
      tip: '最多{max}张，每张不超过 10MB，总大小不超过50MB',
      processing: '正在处理中...',
      onlyImages: '只能上传图片文件!',
      sizeLimit: '图片大小不能超过10MB!',
      totalSizeLimit: '所有图片总大小不能超过50MB',
      maxFiles: '最多只能选择{max}张图片',
      fileExists: '文件 {name} 已存在，跳过添加',
      added: '已添加 {name}，当前共 {count} 张图片',
      removed: '已移除 {name}，剩余 {count} 张图片',
      waitTranslate: '正在翻译中，请等待翻译完成后再添加图片',
    },
    fileList: {
      empty: '暂无翻译记录',
      selectAll: '全选 ({selected}/{max})',
      timeJustNow: '刚刚',
      timeMinutesAgo: '{count}分钟前',
      timeHoursAgo: '{count}小时前',
      timeDaysAgo: '{count}天前',
    },
    preview: {
      placeholder: '上传后即可预览漫画',
      clearAll: '清空全部',
      uploading: '上传中 {progress}%',
      joinQueue: '加入翻译队列',
    },
    login: {
      welcomeBack: '欢迎回来',
      createAccount: '创建账户',
      loginSubtitle: '登录以使用VIP专属翻译通道',
      registerSubtitle: '注册后即可体验VIP翻译服务',
      email: '邮箱地址',
      password: '密码',
      confirmPassword: '确认密码',
      loginBtn: '登 录',
      registerBtn: '注 册',
      noAccount: '没有账户？点击注册',
      hasAccount: '已有账户？点击登录',
      forgotPassword: '忘记密码？',
      loginAgreement: '登录即代表已阅读并同意',
      registerAgreement: '注册即代表已阅读并同意',
      and: '与',
      privacyPolicy: '隐私政策',
      channelCompare: '通道对比',
      channelDesc: '了解免费通道与VIP通道的区别，VIP通道需消耗算力',
      freeQueue: '公共队列（免费）',
      freeQueueDesc: '适合不着急的用户，排队等待翻译',
      freeItems: ['无需登录', '完全免费，不消耗算力', '队列优先级低', '每日翻译数量限制', '不支持大图翻译（最大2000×2000）'],
      vipQueue: 'VIP通道（消耗算力）',
      vipQueueDesc: '快速翻译，支持大图，按次消耗算力',
      vipItems: ['需要登录(免费功能全部权益)', '更多翻译设置', '快速队列，优先翻译', '无次数限制，按次数消耗算力', '支持大图翻译（最大2000×20000）'],
      usageTipTitle: '使用建议',
      usageTipDesc: '免费用户可使用公共队列免费翻译，如需快速翻译或翻译大图，可使用VIP通道。购买的算力不过期，可随时使用。',
      emailRequired: '请输入邮箱地址',
      emailInvalid: '请输入有效的邮箱地址',
      passwordRequired: '请输入密码',
      passwordMin: '密码长度不能少于6位',
      confirmRequired: '请确认密码',
      confirmMismatch: '两次输入的密码不一致',
      agreementTitle: '用户协议',
      privacyTitle: '隐私政策',
      loginSuccess: '登录成功',
      registerSuccess: '注册成功，请登录',
      loginFailed: '登录失败，请检查邮箱和密码',
      registerFailed: '注册失败，请稍后重试',
    },
    vip: {
      pageTitle: 'VIP专属翻译通道',
      pageDesc: 'VIP专享 · 优先处理 · 专属队列 · 次数不限',
      uploadTitle: 'VIP专属上传',
      previewTitle: 'VIP专属预览',
      historyTitle: 'VIP翻译历史',
      maxImages: '最多 50 张图片',
      eachLimit: '每张不超过 10MB',
      totalLimit: '总大小不超过 50MB',
      batchMax: '最大支持批量50张',
      clearHistory: '清空中...',
      clear: '清空',
      searchPlaceholder: '请输入文件名称',
      statusLabel: '翻译状态',
      waiting: '等待翻译',
      translating: '翻译中',
      failed: '翻译失败',
      completed: '已完成',
      query: '查询',
      reset: '重置',
      fileName: '漫画名称',
      translateStatus: '翻译状态',
      currentQueue: '当前队列',
      creditsCost: '消耗算力',
      targetLanguage: '目标语言',
      action: '操作',
      noRecords: '暂无翻译记录',
      refresh: '刷新',
      configTitle: '翻译配置',
      configLangLabel: '目标翻译语言',
      configLangPlaceholder: '请选择翻译语言',
      configLayoutLabel: '排版模式',
      configLayoutPlaceholder: '请选择排版模式',
      configConfirm: '确定',
      statusWaiting: '等待翻译',
      statusTranslating: '翻译中',
      statusFailed: '翻译失败',
      statusCompleted: '已完成',
      statusExpired: '已过期',
      statusUnknown: '未知',
      defaultLang: '简体中文',
      fileNotFound: '文件不存在或已被删除',
      serverError: '服务器内部错误，下载失败',
      networkError: '网络异常，请检查网络连接后重试',
      noFileFound: '没有找到对应文件',
      fileNotComplete: '文件翻译尚未完成，请等待',
      fileIdMissing: '文件ID不存在，无法预览',
      selectFilesFirst: '请先选择要下载的文件',
      downloadingWait: '正在下载中，请稍候...',
      incompleteFiles: '选中的文件中有 {count} 个文件尚未完成翻译，无法下载',
      batchDownloadStart: '开始VIP批量下载 {count} 个文件...',
      paramError: '请求参数错误，请检查选择的文件',
      deleteConfirm: '确定要删除这条记录吗？',
      deleteTitle: '提示',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      clearConfirm: '确定要清空所有已完成和失败的翻译记录吗？此操作不可恢复。',
      clearSuccess: '清空成功',
      clearFailed: '清空失败',
    },
    getPower: {
      title: '漫画翻译算力获取',
      subtitle: '获取算力，解锁VIP通道，享受快速翻译、大图翻译等VIP功能。VIP功能无次数限制，按次数消耗算力订阅。遇到问题',
      contactAdmin: '联系站长',
      currentBalance: '当前算力余额',
      creditsUnit: '算力',
      packageTitle: '算力购买套餐',
      packageDesc: '选择以下套餐购买算力，算力可用于VIP通道，永久有效不过期',
      noPackage: '暂无可购买的套餐',
      payMethod: '支付方式',
      alipay: '支付宝',
      wechatPay: '微信支付',
      selectPackage: '请选择套餐',
      buyButton: '立即购买',
      privacyTitle: '隐私保护',
      privacyDesc: '为保障用户隐私，本系统不存储任何用户翻译的图片，翻译完成后24小时内自动清除所有翻译数据。翻译完成后，请及时下载。',
      channelCompare: '通道对比',
      channelDesc: '了解免费通道与VIP通道的区别，VIP通道需消耗算力',
      usageTipTitle: '使用建议',
      usageTipDesc: '免费用户可使用公共队列免费翻译，如需快速翻译或翻译大图，可使用VIP通道。购买的算力不过期，可随时使用。',
      calcTitle: '算力计算公式',
      calcDesc: '常规图片消耗1算力，长图/超高分辨率图片消耗更多算力。2算力对应分辨率大于4K。',
      payPending: '等待支付',
      paySuccess: '支付成功！',
      payFailed: '支付失败',
      createOrderFailed: '创建支付订单失败',
      pleaseSelectPackage: '请先选择套餐',
      qrcodeTitle: '扫码支付',
      qrcodeDesc: '请使用{method}扫码支付',
      payConfirming: '支付确认中...',
      payTimeout: '支付超时，请重试',
    },
    order: {
      loading: '加载中...',
      typeGift: '赠送',
      typeAlipay: '支付宝',
      typeWechat: '微信',
      typeBilibili: 'B站赞助',
      typePaypal: 'PayPal',
      payProcessing: '支付处理中...',
      backHome: '返回首页',
      statePending: '待支付',
      stateSuccess: '支付成功',
      stateFailed: '支付失败',
      stateConfirming: '待确认',
      stateClosed: '已关闭',
      unknown: '未知',
    },
    userMessage: {
      pending: '待处理',
      replied: '已回复',
      placeholder: '请输入您想说的话...',
      submitting: '提交中...',
      submit: '提交',
      messageContent: '留言内容',
      suggestionContent: '建议内容',
      message: '留言',
      suggestion: '建议',
    },
    userProfile: {
      nicknamePlaceholder: '请输入昵称',
      phoneBound: '已绑定 {phone}',
      phoneUnbound: '未绑定手机',
      emailBound: '已绑定 {email}',
      emailUnbound: '未绑定邮箱',
      wechatBound: '已授权绑定微信账号',
      wechatUnbound: '未绑定微信',
      change: '更换',
      bind: '绑定',
      unbind: '解绑',
      selectImageError: '请选择图片文件',
      imageSizeError: '图片大小不能超过5MB',
      avatarSuccess: '头像上传成功',
      avatarFailed: '上传失败',
      avatarRetry: '上传失败，请重试',
      saveSuccess: '个人信息保存成功',
      saveFailed: '保存失败',
      saveRetry: '保存失败，请重试',
    },
    resetPassword: {
      title: '重置密码',
      step1: '验证邮箱',
      step2: '输入验证码',
      step3: '设置新密码',
      emailPlaceholder: '请输入注册邮箱',
      sendCode: '发送验证码',
      codePlaceholder: '请输入验证码',
      newPassword: '新密码',
      confirmPassword: '确认密码',
      resetBtn: '重置密码',
      backToLogin: '返回登录',
      stepDesc1: '请输入您注册时使用的邮箱地址',
      stepDesc2: '请输入收到的6位验证码',
      stepDesc3: '请设置您的新密码',
      codeSentTo: '验证码已发送至:',
      resendAfter: '{countdown}s 后可重新发送',
      resendCode: '重新发送验证码',
      verifyBtn: '验 证',
      codeRequired: '请输入验证码',
      codeLen: '验证码为6位数字',
      emailRequired: '请输入邮箱地址',
      emailInvalid: '请输入有效的邮箱地址',
      passwordRequired: '请输入密码',
      passwordMin: '密码长度不能少于6位',
      confirmRequired: '请确认密码',
      confirmMismatch: '两次输入的密码不一致',
      codeSentSuccess: '验证码已发送，请查收邮件',
      verifySuccess: '验证成功，请设置新密码',
      resetSuccess: '密码修改成功，请重新登录',
    },
    seo: {
      landing: {
        title: 'KokeManga 智能漫画翻译工具 - AI驱动 · 批量翻译 · 原图渲染',
        description: 'KokeManga是一款免费的在线漫画翻译工具，支持多种格式漫画翻译，包括JPG、PNG、WEBP等格式，AI智能翻译和批量处理。',
      },
      translate: {
        title: 'KokeManga 漫画翻译 - 在线漫画翻译工具',
        description: '在线漫画翻译工具，支持批量上传、自动翻译、原图渲染',
      },
      vip: {
        title: 'KokeManga VIP专属翻译通道',
        description: 'VIP专享漫画翻译通道，优先处理、专属队列、次数不限',
      },
    },
    privacy: {
      intro: '欢迎使用我们的在线漫画翻译工具。我们高度重视您的隐私和数据安全。本隐私条款旨在清晰说明我们如何收集、使用、存储和处理您的信息，特别是您上传的漫画图片。',
      s1Title: '1. 信息的收集',
      s1Content: '我们仅收集和访问您在使用本工具时主动选择并上传的漫画图片文件。除此之外，我们不主动收集、存储或请求您的任何其他个人身份信息（如姓名、邮箱、IP地址、设备信息等）。',
      s2Title: '2. 信息的使用方式',
      s2Content: '您上传的漫画图片仅用于提供您所要求的即时翻译服务。核心的图像处理、文字识别与翻译计算均在您的本地浏览器或设备中进行。我们承诺：',
      s2Item1: '本地处理：上传的图片文件不会被自动、主动或常规性地传输至我们的服务器或任何第三方服务器进行处理。',
      s2Item2: '目的限定：图片内容仅用于生成翻译结果，不会被用于任何其他目的，包括但不限于机器学习模型训练、内容分析、营销或任何形式的再分发。',
      s3Title: '3. 信息的存储与保留',
      s3Content: '我们深知临时文件的安全性。我们的数据存储原则如下：',
      s3Item1: '自动清除：所有您上传的原始图片文件及生成的翻译结果，将在处理完成后的24小时内，从我们的系统内被永久且不可恢复地删除。',
      s3Item2: '无长期存档：我们不设立、也不保留任何与您上传内容相关的长期数据库、档案或备份。',
      s4Title: '4. 您的权利',
      s4Content: '作为数据的提供者，您拥有以下权利：',
      s4Item1: '控制权：您完全控制所上传的内容。您可以在使用后随时关闭浏览器标签页。',
      s4Item2: '知情权：您有权通过本条款了解我们如何处理您的文件。',
      s5Title: '5. 第三方服务',
      s5Content: '当前服务不涉及嵌入第三方分析、广告或跟踪工具。如果未来引入任何可信的第三方服务以改善功能，我们将在本条款中明确说明，并确保其符合同等严格的隐私标准。',
      s6Title: '6. 隐私条款的变更',
      s6Content: '我们可能不时更新本隐私条款。如有重大变更，我们将在工具界面发布显著通知。您继续使用我们的服务即表示接受更新后的条款。',
      s7Title: '7. 联系我们',
      s7Content: '如果您对本隐私条款或我们的数据处理实践有任何疑问、意见或顾虑，请通过以下方式联系我们：Koke7359@163.com',
      s8Title: '8. 适用法律',
      s8Content: '本隐私条款的订立、执行和解释均适用于中华人民共和国法律',
    },
    agreement: {
      updateDate: '最后更新日期：2026年4月2日',
      intro: '欢迎使用本在线漫画翻译工具（以下简称"本工具"或"本服务"）。请您在使用前仔细阅读并理解本《用户协议》（以下简称"本协议"）的全部内容。如果您不同意本协议的任何条款，请立即停止使用本工具。您的上传、访问或使用行为即视为您已阅读、理解并同意完全接受本协议及我们的《隐私条款》的约束。',
      s1Title: '1. 服务描述',
      s1Content: '本工具为您提供一项免费的在线技术翻译服务：您上传包含文字的漫画图片，我们将通过技术手段（如图像识别、机器翻译）为您生成翻译结果。您理解并同意，翻译结果由算法自动生成，仅为辅助理解之用，其准确性、完整性、适用性不作任何明示或默示的保证。',
      s2Title: '2. 用户行为规范',
      s2Content: '您承诺遵守所有适用的法律法规，并独立承担因使用本服务所产生的全部责任。您在使用本服务时，不得从事以下行为：',
      s2Subtitle1: '上传、传输、分享或存储任何含有以下内容或与之相关的漫画图片：',
      s2Item1: '侵权内容：侵犯他人知识产权（如著作权、商标权）、肖像权、隐私权或其他合法权益的内容。',
      s2Item2: '违法与违规内容：违反任何法律、法规、规章、条例的内容，或包含任何非法、欺诈、诽谤、骚扰、恐吓性的信息。',
      s2Item3: '有害与不良内容：包含色情、淫秽、暴力、血腥、仇恨言论，或宣扬种族、性别、宗教、残疾、性取向等歧视的内容。',
      s2Item4: '敏感内容：涉及国家秘密、国家安全、公共安全、政治敏感及未成年人不适宜的内容。',
      s2Subtitle2: '其他禁止行为：',
      s2Item5: '将本工具用于任何商业目的、非法目的，或进行任何干扰、破坏服务正常运行的行为（如尝试入侵系统、上传恶意软件等）。',
      s2Item6: '冒充任何个人或实体，或虚假陈述您与任何个人或实体的关联。',
      s3Title: '3. 用户上传内容的责任',
      s3Content1: '您应对您上传的全部漫画图片内容（以下简称"用户内容"）承担全部法律责任。您保证，您拥有上传该等内容所需的一切合法权利或已获得充分授权，且该等内容的使用不违反任何法律或侵犯任何第三方权益。',
      s3Content2: '一旦您上传的内容违反本协议，相关法律责任由您自行承担，如因此给我们或任何第三方造成损失的，您应负责全额赔偿。',
      s4Title: '4. 知识产权',
      s4Content1: '您的权利：您保留对您上传的原始漫画图片所拥有的所有知识产权及相关权利。您上传行为本身，不意味着您将任何权利转让给我们。',
      s4Content2: '我们的权利：本工具及其提供的服务（包括但不限于软件、界面、logo、技术）所包含的一切知识产权和相关权利，均归我们及/或许可方所有。未经我们明确书面许可，您不得以任何形式复制、修改、反向工程或进行商业性使用。',
      s5Title: '5. 服务的变更、中断与终止',
      s5Content1: '我们保留随时修改、暂停或中断本服务（或其中任何部分）的权利，且无需事先通知您，也无需对您或任何第三方承担任何责任。',
      s5Content2: '如果我们有合理理由认为您违反了本协议的任何规定，我们有权单方面立即暂停或终止向您提供服务，并删除相关用户内容，而无需承担任何责任。',
      s6Title: '6. 免责声明',
      s6Content: '在适用法律允许的最大范围内，本服务按"现状"和"可用"提供，我们不提供任何形式的明示或默示保证。您理解并同意：',
      s6Item1: '我们不保证服务不中断、及时、安全或无错误。',
      s6Item2: '我们不保证翻译结果的准确性、可靠性或适用性。翻译结果仅供参考，不构成专业翻译建议，您应自行判断其价值并对使用结果负责。',
      s6Item3: '我们对因您上传的内容导致的任何直接、间接、附带、惩罚性或后果性的损失（包括但不限于数据丢失、利润损失、商誉损失）不承担责任，无论我们是否已被告知可能发生此类损害。',
      s7Title: '7. 数据保留',
      s7Content: '您确认并同意，我们依据《隐私条款》对您上传的图片及生成的翻译结果进行临时处理。所有数据将在处理完成后24小时内自动清除。您有责任自行备份您希望保留的任何内容。',
      s8Title: '8. 协议的修改',
      s8Content: '我们有权随时更新或修改本协议。更新后的协议将在本页面公布，并更新"最后更新日期"。您继续使用本服务即表示接受更新后的协议。建议您定期查阅本页面以了解最新条款。',
      s9Title: '9. 其他规定',
      s9Item1: '可分性：如果本协议的任何条款被认定为无效或不可执行，该条款应在最小必要范围内进行限制或排除，其他条款的效力不受影响。',
      s9Item2: '完整协议：本协议与我们的《隐私条款》共同构成您与我们之间关于本服务的完整协议，并取代任何先前的口头或书面协议。',
    },
    about: {
      title: '欢迎来到 Koke',
      intro: '我们始于一个简单的信念：语言不应成为探索精彩漫画世界的屏障。',
      missionTitle: '我们的使命',
      missionContent: 'Koke 致力于打造一款真正高效、简洁且免费的智能翻译工具，让每一位漫画爱好者都能无障碍地享受阅读的乐趣。我们相信，科技应当服务于人，以最无感的方式消除障碍，让精彩的故事和艺术直达人心。',
      coreTitle: '我们的核心：您的隐私与便捷',
      toolTitle: '纯粹的工具',
      toolContent: 'Koke 是一款功能聚焦的工具。您上传，我们翻译，如此而已。我们不做社区，不存储内容，不追踪用户。',
      privacyTitle: '隐私至上',
      privacyContent: '您的数据只为您服务。为最大限度保护您的隐私，翻译所需的图像处理与识别均在您的本地浏览器中完成，我们不会将您的原始图片传输至服务器。所有相关数据将在24小时后自动彻底清除，我们不留存任何副本。这是我们对您信任的承诺。',
      efficientTitle: '简洁高效',
      efficientContent: '我们摒弃一切不必要的功能与复杂的界面，专注于提升从上传到获得翻译结果的整体速度与体验，让翻译如翻页般自然流畅。',
      futureTitle: '展望未来',
      futureContent: '我们将持续优化翻译的准确性与对复杂版式的处理能力，并严格恪守"高效、简洁、免费、安全"的初心。我们希望 Koke 能成为您探索漫画宇宙时，手中那把轻巧而可靠的钥匙。',
      thankYou: '感谢您的使用。',
      signature: 'Koke 团队 敬上',
    },
  },
}
